import React from 'react';
import i18next from 'i18next';
import { number, string } from 'prop-types';

import styles from './styles.module.scss';

const SectionHeader = ({ num, titleKey, subtitleKey }) => (
  <div className={styles.sectionHeader}>
    <div className={styles.sectionTitleRow}>
      <span className={styles.sectionNum}>{num}</span>
      <h2 className={styles.sectionTitle}>{i18next.t(titleKey)}</h2>
    </div>
    {subtitleKey && <p className={styles.sectionSubtitle}>{i18next.t(subtitleKey)}</p>}
  </div>
);

SectionHeader.propTypes = {
  num: number.isRequired,
  titleKey: string.isRequired,
  subtitleKey: string
};

export default SectionHeader;
